import React from 'react';
import { observer } from 'mobx-react';
import { ProfileWrapper, Indicator, Center } from 'legacyComponents/styled/lib';
import { media } from 'legacyComponents/styled/styleUtils';
import styled from 'styled-components';

export const ProfileIndicator = observer(() => (
  <ProfileWrapper>
    <Center>
      <AvatarIndicator />
    </Center>
    <NameIndicator />
    <UsernameIndicator />
    <BioLineOneIndicator />
    <BioLineTwoIndicator />
  </ProfileWrapper>
));

const AvatarIndicator = styled(Indicator)`
  width: 126px;
  height: 126px;
  margin-top: -50px;
  border-radius: 100%;
  z-index: 14;
  ${media.s`
    width: 100px;
    height: 100px;
    margin-top: -50px;
  `}
`;

const NameIndicator = styled(Indicator)`
  height: 27px;
  width: 200px;
  margin: 10px auto 0px auto;
  ${media.s`
    height: 24px;
    width: 180px;
  `}
`;

const UsernameIndicator = styled(Indicator)`
  width: 80px;
  height: 16px;
  margin: 5px auto 10px auto;
`;

const BioLineOneIndicator = styled(Indicator)`
  width: 500px;
  margin: 5px auto 5px auto;
  ${media.s`
    width: 400px;
  `}
  ${media.xs`
    width: calc(100% - 40px);
  `}
`;

const BioLineTwoIndicator = styled(BioLineOneIndicator)`
  width: 340px;
  ${media.s`
    width: 280px;
  `}
  ${media.xs`
    width: calc(100% - 80px);
  `}
`;
